import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface ViewsSliceState {
    segmentId?: string;
}

const initialState: ViewsSliceState = {
    segmentId: undefined,
};

export const viewsSlice = createSlice({
    name: 'views',
    initialState,
    reducers: {
        setSegmentId(state, action: PayloadAction<{ segmentId: string | undefined }>) {
            const { segmentId } = action.payload;
            return { ...state, segmentId };
        },
    },
});

export const { setSegmentId } = viewsSlice.actions;
